<script>
    export let window;

    let index = window.props.index || 0;

    $: hasPrevious = index > 0;
    $: hasNext = index < window.props.photos.length - 1;

    function notify() {
        dispatchEvent(new CustomEvent("photo-index", { detail: index }));
    }

    function previous() {
        if (hasPrevious) {
            index -= 1;
            notify();
        }
    }

    function next() {
        if (hasNext) {
            index += 1;
            notify();
        }
    }

    function cycle() {
        if (hasNext) {
            index += 1;
        } else {
            index = 0;
        }

        notify();
    }

    function didClickPreviousButton() {
        previous();
    }

    function didClickNextButton() {
        next();
    }

    function didPressKey(e) {
        if (!window.isFocused) {
            return;
        }

        switch (e.key) {
            case "ArrowLeft":
                e.preventDefault();
                previous();
                break;

            case " ":
                e.preventDefault();
                cycle();
                break;

            case "ArrowRight":
                e.preventDefault();
                next();
                break;

            default:
                break;
        }
    }
</script>

<svelte:window on:keydown={didPressKey} />

<button class:disabled={!hasPrevious} on:click={didClickPreviousButton}>
    <span>
        <svg width="11" height="13" viewBox="0 0 11 13" fill="none">
            <path d="M0 13V0L10.5 6.5L0 13Z" fill="black" />
        </svg>
    </span>
</button>

<button
    class="disabled"
    class:disabled={!hasNext}
    on:click={didClickNextButton}
>
    <svg width="11" height="13" viewBox="0 0 11 13" fill="none">
        <path d="M0 13V0L10.5 6.5L0 13Z" fill="black" />
    </svg>
</button>

<div class="spacer" />

<div class="counter">
    {index + 1} / {window.props.photos.length}
</div>

<style>
    button {
        appearance: none;
        cursor: pointer;
        margin: calc(var(--chrome-depth) * 3);
        border: none;
        background: none;
        padding: 0;
        touch-action: manipulation;
        color: black;
    }

    button:active {
        opacity: 0.5;
    }

    span {
        display: block;
        transform: scaleX(-1);
    }

    .disabled {
        opacity: 0.25 !important;
        cursor: default;
    }

    .spacer {
        flex-grow: 1;
    }

    .counter {
        position: relative;
        top: -1px;
        margin: calc(var(--chrome-depth) * 3);
    }
</style>
